"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "toggleBackgroundHiddenMiddleware", {
  enumerable: true,
  get: function get() {
    return _toggleBackgroundHiddenMiddleware["default"];
  }
});
var _toggleBackgroundHiddenMiddleware = _interopRequireDefault(require("./toggleBackgroundHiddenMiddleware"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }